import Styled from './Styled.styled';
import Spinner from '../Spinner/Spinner';

function LoadingPage() {
    return (
        <Styled>
            <Spinner />
        </Styled>)
}

export default LoadingPage